<template>
    <div class="modal fade modal-upload" id="addUser" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">

                <div v-show="(loading == true)" class="loading-backdrop">
                    <div class="loading"></div>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <form class="" @submit.prevent="addUser">
                        <div class="center-modal ex-input-center">
                            <div class="center-ttl text-center">
                                {{ $t('user.add.title') }}
                            </div>

                            <div class="error-message" v-if="alert_error" data-vv-scope='s1'>
                                <div class="d-flex">
                                    <i class="icon-warning mr-2"></i>
                                    <div class="errror-txt">
                                        <p class="fs-14 text-red font600">{{ $t('error.title') }}</p>
                                        <p class="fs-14 text-red font600">{{ alert_error }}</p>
                                    </div>
                                </div>
                            </div>

                            <div v-if="(passwordNew == null) && (init == true)" class="" data-vv-scope='s2'>
                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('user.general.username') }} <span class="text-red">*</span>
                                    </label>
                                    <!-- <div class="form-input-cnt ex-has-error"> -->
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('username') }">
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            name="username"
                                            key="username"
                                            v-model="user.username"
                                            class="form-control"
                                            :placeholder="$t('place_holder.username')"
                                            :data-vv-as="$t('user.general.username')"
                                            v-validate.disable="{required:true,min:1,max:100,regex:/^[a-zA-Z0-9@\-_\.]*$/}">
                                        <div v-show="errors.has('username')" class="error-text">{{ errors.first('username') }}</div>
                                    </div>
                                </div>

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('user.general.full_name') }} <span class="text-red">*</span>
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('fullName') }">
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            name="fullName"
                                            key="fullName"
                                            v-model="user.fullName"
                                            class="form-control"
                                            :placeholder="$t('place_holder.full_name')"
                                            :data-vv-as="$t('user.general.full_name')"
                                            v-validate.disable="'required|min:1|max:255'">
                                        <div v-show="errors.has('fullName')" class="error-text">{{ errors.first('fullName') }}</div>
                                    </div>
                                </div>

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('company.general.full_name') }} <span class="text-red">*</span>
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('companyId') }">
                                        <select2
                                                id="companyId"
                                                v-model="user.companyId"
                                                :data-vv-as="$t('company.general.full_name')"
                                                v-validate.disable="'required'"
                                                class=""
                                                name="companyId"
                                                key="companyId"
                                                :options="selectCompanyId"
                                                :settings="selectCompanyIdSettings"
                                                @change="selectCompanyIdChangeEvent($event)"
                                                @select="selectCompanyIdEvent($event)"></select2>
                                        <div v-show="errors.has('companyId')" class="error-text">{{ errors.first('companyId') }}</div>
                                    </div>
                                </div>

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('group.general.name') }} <span class="text-red">*</span>
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('groupId') }">
                                        <select2
                                                id="groupId"
                                                v-model="user.groupId"
                                                :data-vv-as="$t('group.general.name')"
                                                v-validate.disable="'required'"
                                                class=""
                                                name="groupId"
                                                key="groupId"
                                                :options="selectGroupId"
                                                :settings="selectGroupIdSettings"
                                                @change="selectGroupIdChangeEvent($event)"
                                                @select="selectGroupIdEvent($event)"></select2>
                                        <div v-show="errors.has('groupId')" class="error-text">{{ errors.first('groupId') }}</div>
                                    </div>
                                </div>

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('user.general.role') }} <span class="text-red">*</span>
                                    </label>

                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('roleId') }">
                                        <select2
                                                id="roleId"
                                                v-model="user.roleId"
                                                class=""
                                                name="roleId"
                                                key="roleId"
                                                :data-vv-as="$t('user.general.role')"
                                                v-validate.disable="'required'"
                                                :options="selectRoleId"
                                                :settings="selectRoleIdSettings"
                                                @change="selectRoleIdChangeEvent($event)"
                                                @select="selectRoleIdEvent($event)"></select2>
                                        <div v-show="errors.has('roleId')" class="error-text">{{ errors.first('roleId') }}</div>
                                    </div>
                                </div>

                                <!-- <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('user.general.period') }}
                                    </label>
                                    <div class="form-input-cnt">
                                       <date-picker
                                            :placeholder="$t('place_holder.period')"
                                            format="YYYY.MM.DD"
                                            v-model="range_date"
                                            :disabled-date="notBeforeDate"
                                            :editable="false"
                                            range>
                                       </date-picker>
                                    </div>
                                </div> -->

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('user.general.start_date') }}
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('start_date') }">
                                       <date-picker
                                           ref="start_date"
                                           name="start_date"
                                           key="start_date"
                                           :placeholder="$t('place_holder.start_date')"
                                           :data-vv-as="$t('user.general.start_date')"
                                           v-validate.disable="'date_format:yyyy.MM.DD'"
                                           format="YYYY.MM.DD"
                                           v-model="user.validPeriodFrom"
                                           :disabled-date="notBeforeDate"
                                           :editable="false"
                                           @change="changeDate">
                                       </date-picker>
                                       <div v-show="errors.has('start_date')" class="error-text">{{ errors.first('start_date') }}</div>
                                    </div>
                                </div>

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('user.general.end_date') }}
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('end_date') }">
                                       <date-picker
                                           ref="end_date"
                                           name="end_date"
                                           key="end_date"
                                           :placeholder="$t('place_holder.end_date')"
                                           :data-vv-as="$t('user.general.end_date')"
                                           v-validate.disable="'date_format:yyyy.MM.DD'"
                                           format="YYYY.MM.DD"
                                           v-model="user.validPeriodTo"
                                           :disabled-date="notBeforeDate"
                                           :editable="false"
                                           @change="changeDate">
                                       </date-picker>
                                       <div v-show="errors.has('end_date')" class="error-text">{{ errors.first('end_date') }}</div>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-center mt-4 pt-4">
                                    <div class="pr-2 w-165">
                                        <button type="submit" class="btn btn-pink-53 w-100" :disabled="submitted">
                                            {{ $t('button.ok') }}
                                        </button>
                                    </div>

                                    <div class="pl-2 w-165">
                                        <button class="btn btn-gray-53 w-100" data-dismiss="modal" type="button" :disabled="submitted">
                                            {{ $t('button.cancel') }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div v-if="(passwordNew != null) && (init == false)" class="" data-vv-scope='s3'>

                                <p>
                                    <span>{{ $t("login.password") }}</span> :
                                    <span>{{ passwordNew }}</span>
                                </p>

                                <div class="d-flex justify-content-center mt-4 pt-4">
                                    <div class="pl-2 w-165">
                                        <button class="btn btn-pink-53 w-100" data-dismiss="modal" type="button">
                                            {{ $t('button.ok') }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
/* global $ */
import _ from 'lodash';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ja';

import UserManagementService from '@/services/admin/user.service';
import GroupManagementService from '@/services/admin/group.service';
import StorageService from "@/services/common/storage.service";
import { AuthService } from "@/services/common/auth.service";

import Utils from '@/helpers/utils';
import DateUtils from '@/helpers/dateUtils';
import { Constants } from "@/helpers/constants";
import { Role } from '@/helpers/role';
import store from '@/store/index';

export default {
    components: {
        DatePicker,
    },
    name: 'AddUserManagement',
    props: {
    },
    data () {
        let from_date = new Date();
        from_date.setDate(from_date.getDate() + 1);

        let to_date = new Date();
        to_date.setDate(from_date.getDate() + 30);

        return {

            alert_success: "",
            alert_error: "",

            selectRoleId: [],
            selectRoleIdSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.role'),
                data: this.selectRoleId,
            },

            selectCompanyId: [],
            selectCompanyIdSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.company'),
                data: this.selectCompanyId,
            },

            groups: [],
            selectGroupId: [],
            selectGroupIdSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.group'),
                data: this.selectGroupId,
            },

            user: {
                username: "",
                fullName: "",
                companyId: "",
                groupId: "",
                roleId: Role.User.id,
                validPeriodFrom: null,
                validPeriodTo: null,
            },

            loading: false,
            submitted: false,
            init: true,
            passwordNew: null,
        };
    },
    beforeCreate () {
        this.$forceUpdate();
    },
    created () {
        this.resetModal();
        this.getAllRoles();
    },
    beforeMount () {
    },
    mounted () {
        let _this = this;
        $("#addUser").on('show.bs.modal', function () {
            _this.getAllCompanies();
            _this.getAllGroups();
            store.commit('loading', false);
        });
        $("#addUser").on('hide.bs.modal', function () {
            _this.resetModal();
            _this.$emit('unSlectAllUser');
            store.commit('loading', false);
        });
    },
    computed: {
    },
    watch: {
    },
    methods: {
        resetModal: function resetModal () {
            this.user = {
                username: "",
                fullName: "",
                groupId: "",
                roleId: Role.User.id,
                validPeriodFrom: null,
                validPeriodTo: null,
            };

            this.alert_success = "";
            this.alert_error = "";
            this.submitted = false;
            this.loading = false;

            this.init = true;
            this.passwordNew = null;

            this.$validator.reset();
        },

        addUser (e) {
            Utils.trimObject(this.user);

            this.submitted = true;

            this.$validator.validate().then(valid => {
                if (!DateUtils.compareDate(this.user.validPeriodFrom, this.user.validPeriodTo)) {
                    this.$validator.errors.add({
                        field: 'start_date',
                        msg: this.$t('error.error_before_date', { date: this.$t('user.general.start_date') }),
                    });
                } else {
                    this.errors.remove("start_date");
                    this.errors.remove("end_date");
                }

                if (!valid || !DateUtils.compareDate(this.user.validPeriodFrom, this.user.validPeriodTo)) {
                    this.submitted = false;
                    return false;
                }

                this.loading = true;

                UserManagementService.addUser(this.user)
                    .then(response => {
                        if (response.status == 423) {
                            StorageService.saveExpired();
                            AuthService.doLogout();
                        }
                        if (response.status == 200) {
                            if (response.data) {
                                this.init = false;

                                if (!Utils.isEmptyStr(response.data.password)) {
                                    this.passwordNew = response.data.password;
                                } else {
                                    $('#resetPassUser').modal('hide');
                                    $('.modal-backdrop').remove();
                                }
                            } else {
                                $('#resetPassUser').modal('hide');
                                $('.modal-backdrop').remove();
                            }

                            this.alert_success = this.$t('success.add_success');
                            this.alert_error = "";
                            this.$toasted.success(this.alert_success, {icon: 'fa-check'});
                            this.$emit('updateListUser');

                            /*
                            $('#addUser').modal('hide');
                            $('.modal-backdrop').remove();
                            */
                        } else if (response.status == 202) {
                            this.init = false;
                            this.user.password = Constants.remakePassword;
                            UserManagementService.editUser([response.data.id], this.user, false, false)
                                .then(response => {
                                    this.passwordNew = Constants.remakePassword;
                                    this.alert_success = this.$t('success.add_success');
                                    this.alert_error = "";
                                    this.$toasted.success(this.alert_success, {icon: 'fa-check'});
                                    this.$emit('updateListUser');
                                });
                        } else {
                            this.alert_success = "";
                            this.alert_error = this.$t('fail.add_fail');

                            let errorCode = Utils.getErrorCode(response);
                            if (errorCode) {
                                this.alert_error = this.$t('error.error_code_' + errorCode);
                            }

                            // this.$toasted.error(this.alert_error, {icon: 'fa-exclamation-triangle'});
                        }

                        if (response.status == 403) {
                            this.alert_success = "";
                            this.alert_error = this.$t('error.error_' + response.status);
                        }

                        this.loading = false;
                        this.submitted = false;
                        this.$validator.reset();
                    }).catch(error => {
                        this.alert_success = "";
                        this.alert_error = this.$t('fail.add_fail');

                        // $('#addUser').modal('hide');
                        // $('.modal-backdrop').remove();
                        // this.$toasted.error(this.alert_error, {Icon: 'fa-exclamation-triangle'});

                        this.loading = false;
                        this.submitted = false;
                        this.$validator.reset();
                    });
            });
        },

        getAllRoles: function getAllRoles () {
            let userRole = StorageService.getUserRole();

            let _dataSelect = [];
            $.each(Role, function (key, value) {
                if (value.id >= userRole) {
                    let item = {
                        id: value.id,
                        text: value.name,
                    };
                    _dataSelect.push(item);
                }
            });
            this.selectRoleId = _dataSelect;
        },

        getAllCompanies: function getAllCompanies () {
            GroupManagementService.getAllCompanies()
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data) {
                        let _dataSelect = [];
                        $.each(response.data, function (key, value) {
                            if (Utils.isEmptyStr(value.id) && Utils.isEmptyStr(value.name)) {
                                return ;
                            }

                            let item = {
                                id: value.id,
                                text: value.name,
                            };
                            _dataSelect.push(item);
                        });

                        this.selectCompanyId = _dataSelect;
                    } else {
                        this.selectCompanyId = [];
                    }
                }).catch(error => {
                    this.selectCompanyId = [];
                });
            return ;
        },

        getAllGroups: function getAllGroups () {
            GroupManagementService.getAllGroups()
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data) {
                        let _dataSelect = [];
                        $.each(response.data, function (key, value) {
                            if (Utils.isEmptyStr(value.branch_name) && Utils.isEmptyStr(value.department_name) && Utils.isEmptyStr(value.name)) {
                                return true;
                            }

                            let text = "";
                            if (!Utils.isEmptyStr(value.branch_name)) {
                                text += value.branch_name;
                            }
                            if (!Utils.isEmptyStr(value.department_name)) {
                                text += "・" + value.department_name;
                            }
                            if (!Utils.isEmptyStr(value.name)) {
                                text += "・" + value.name;
                            }

                            let item = {
                                id: value.id,
                                text: text,
                                company_id: value.company_id,
                            };
                            _dataSelect.push(item);
                        });

                        this.selectGroupId = _dataSelect;
                        this.groups = _dataSelect;
                    } else {
                        this.selectGroupId = [];
                        this.groups = [];
                    }
                }).catch(error => {
                    this.selectGroupId = [];
                    this.groups = [];
                });
            return false;
        },

        selectRoleIdChangeEvent (val) {
        },

        selectRoleIdEvent ({id, text}) {
        },

        selectGroupIdChangeEvent (val) {
        },

        selectGroupIdEvent ({id, text}) {
        },

        selectCompanyIdChangeEvent (val) {
            if (Utils.isEmptyStr(val)) {
                this.selectGroupId = this.groups;
                return ;
            }
            const _groupRefer = _.filter(this.groups, function (n) {
                return  n.company_id == val;
            });
            this.selectGroupId = _groupRefer;
        },

        selectCompanyIdEvent ({id, text}) {
        },

        notBeforeDate (date) {
            let today = new Date();
            today.setDate(new Date().getDate() - 1);
            return date <= today;
        },

        changeDate (date) {
            /*
                this.errors.remove("start_date");
                this.errors.remove("end_date");

                if(!Utils.compareDate(this.user.validPeriodFrom, this.user.validPeriodTo)) {
                    this.$validator.errors.add({
                      field: 'start_date',
                      msg: this.$t('error.error_before_date', { date: this.$t('user.general.start_date')})
                    });
                }
                */
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/admin/UserManagement/Add.vue